export default {
      id: "drop-up-caret-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#drop-up-caret",
      toString: function () {
        return this.url;
      }
    }